import moment from 'moment';

export const columns = [
  {
    field: 'id',
    headerName: 'ID',
    type: 'number',
    hide: true,
    hideable: false,
    filterable: false,
    getApplyQuickFilterFn: undefined,
  },
  {
    field: 'animalName',
    headerName: 'Produkcja zwierzęca',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'incomeValue',
    headerName: 'Wartość wskaźnika PLN',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'expiryDate',
    headerName: 'Data obowiązywania',
    minWidth: 150,
    flex: 1,
    renderCell: (params) => {
      return moment.unix(params.value / 1000).format('DD-MM-YYYY');
    },
  },
];
